import * as z from 'zod';

import { awardQuerySchema } from './award-query-schema';

export const awardMutationSchema = awardQuerySchema
  .omit({
    brand: true,
    client: true,
  })
  .extend({
    gallery: z.array(z.number()),
  });

export type AwardMutationSchema = z.infer<typeof awardMutationSchema>;

export const awardCreateSchema = awardMutationSchema.omit({
  id: true,
});

export type AwardCreateSchema = z.infer<typeof awardCreateSchema>;
